/**
 * @enum FieldEntityType
 */
enum FieldEntityType {
  ORGANIZATION = "ORGANIZATION",
  PARTICIPANT = "PARTICIPANT",
  FEEDBACK = "FEEDBACK",
  PRODUCT = "PRODUCT",
  EVENT_AGENDA = "EVENT_AGENDA"
}

export const DisplayLabelAllowedFieldEntityTypeList = [
  FieldEntityType.PARTICIPANT,
  FieldEntityType.ORGANIZATION,
  FieldEntityType.PRODUCT,
  FieldEntityType.EVENT_AGENDA
];

export const RegistrationOrProfileFieldEntityTypeList = [FieldEntityType.PARTICIPANT, FieldEntityType.ORGANIZATION];

export const FeedbackFieldEntityTypeList = [FieldEntityType.FEEDBACK];

export const AllowedForAITextEnhancementEntityList = [
  FieldEntityType.PARTICIPANT,
  FieldEntityType.ORGANIZATION,
  FieldEntityType.PRODUCT
];

export const DisplayTypeFieldExcludeList = [FieldEntityType.FEEDBACK, FieldEntityType.EVENT_AGENDA];

export default FieldEntityType;
